import * as React         from 'react';
import classNames         from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link }           from 'react-router-dom';

import { useBookmarks } from '../../providers/bookmarks';
import { useCatalog }   from '../../providers/catalog';
import { useUser }      from '../../providers/user';

import CloseIcon from '../icons/CloseIcon';

const ClearBookmarksModal = function() {
  const { t } = useTranslation();

  const bookmarks = useBookmarks();
  const catalog   = useCatalog();
  const user      = useUser();

  const modalRef = React.useRef(null);

  const [show, setShow] = React.useState(false);

  const closeModal            = React.useCallback(() => {
    if (show) {
      setShow(false);
    }

    bookmarks.hideModal();
  }, [show]);
  const clearBookmarksHandler = React.useCallback(() => {
    user.clearBookmarks();

    closeModal();
  }, [closeModal]);
  const keyDown               = React.useCallback((event) => {
    if (bookmarks.open && show && event.key === 'Escape') {
      closeModal();
    }
  }, [bookmarks.open, show, closeModal]);
  const handleClickOutside    = React.useCallback((event) => {
    if (bookmarks.open && modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  }, [bookmarks.open, closeModal]);

  React.useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show, handleClickOutside, keyDown]);
  React.useEffect(() => {
    if (bookmarks.open && !show) {
      setShow(true);
    }
  }, [bookmarks.open]);
  React.useEffect(() => {
    document.body.classList.toggle('fixed', bookmarks.open && show);
  }, [bookmarks.open, show]);

  return (
    <div className={classNames('modal-overlay bookmarks_modal_overlay', { show })}>
      <div
        className={'modal bookmarks_modal'}
        ref={modalRef}
      >
        <span
          className={'close'}
          onClick={closeModal}
        ><CloseIcon /></span>
        <p className={'bookmarks_modal_title'}>
          {Object.keys(user.bookmarks).length ? t('client_bookmarks_delete') : t('client_bookmarks_empty')}
        </p>
        {Object.keys(user.bookmarks).length
          ? (
            <div className={'bookmarks_modal_btns_wrapper'}>
              <button
                className={classNames('btn', 'primary')}
                onClick={clearBookmarksHandler}
              >{t('btn_clear')}</button>
              <button
                className={classNames('btn', 'fill')}
                onClick={closeModal}
              >{t('btn_cancel')}</button>
            </div>
          )
          : (
            <Link
              className={classNames('btn', 'fill', 'add_doors_btn')}
              onClick={() => {
                void catalog.resetFilter();
                void catalog.getCatalogItems('/vhodnye-dveri');

                closeModal();
              }}
              to={'/vhodnye-dveri'}
            >{t('label_goToCatalog')}</Link>
          )
        }
      </div>
    </div>
  );
};

export default ClearBookmarksModal;